import type { ComponentProps, ComponentState, Slot } from '@fluentui/react-components';

export type SensitivityIconSlots = {
  root: NonNullable<Slot<'span'>>;
  foregroundIcon?: Slot<'span'>;
  backgroundIcon?: Slot<'span'>;
};

export type SensitivityLevel = 'general' | 'non-business' | 'public' | 'confidential' | 'highly-confidential';

/**
 * SensitivityIcon Props
 */
export type SensitivityIconProps = ComponentProps<SensitivityIconSlots> & {
  fillColor?: string;
  withLock?: boolean;
};

/**
 * State used in rendering SensitivityIcon
 */
export type SensitivityIconState = ComponentState<SensitivityIconSlots>;
